import { PlayerEnvironment } from "../player_environment";
import CookieUtils from '../utils/cookie_utils';
import UserSession from '../utils/user_session'
import { PlayerAhoyEvent } from "../player_ahoy_event";
import BlockerButtonHelper from "../service/blocker/button_helper";
import i18n from "../utils/i18n";

export default class Adult {
  static runPlugin(options) {
    if (options.enable) {
      const adult = new Adult(options);
      adult.checkUserSession();
    }
  }

  constructor(options = {}) {
    this._player = options.player;
    this._testMode = options.testMode;
    this._data = options.data;
    this._userId = undefined;
    this._blocker = options.blocker;
  }

  player() {
    return this._player;
  }

  data() {
    return this._data;
  }

  testMode() {
    return this._testMode;
  }

  userId() {
    return this._userId;
  }

  blocker() {
    return this._blocker;
  }

  checkUserSession() {
    if (window.currentUser === undefined) {
      const notice = Adult.createAdultNotice();
      this.player().el().appendChild(notice);
      document.addEventListener('user.data.loaded', () => {
        const currentUser = UserSession.userId();
        notice.parentNode.removeChild(notice);
        this.init(currentUser);
      })
    } else {
      this.init(UserSession.userId());
    }
  }

  init(userId) {
    if (Adult.shouldSkipAdultBlocker()) {
      Adult.setAdultConfirmId(userId);
      return;
    }

    const adultConfirmId = CookieUtils.getCookie('adult_confirm_id');
    const userIsLogin = userId !== undefined;
    const userHasConfirm = Adult.userHasConfirm(userId, adultConfirmId);

    if ((!userIsLogin) || (userIsLogin && !userHasConfirm)) {
      Adult.createAdultBlocker(this.player(), userId, this.data(), this.blocker());
      Adult.sendEvent(this.data());
    }
  }

  static shouldSkipAdultBlocker() {
    return PlayerEnvironment.locationSearch().includes('pb_sac');
  }

  static adultCallback(blocker, userId) {
    return () => {
      let blockerElement = document.querySelector('.vjs-player-error__section');

      blockerElement.parentNode.removeChild(blockerElement);
      blocker.tech.error(null);
      blocker._isShown = false;
      player.tech().play();
      Adult.setAdultConfirmId(userId);
    }
  }

  static createAdultBlocker(player, userId, data, blocker) {
    const message = i18n('blocker.adult');

    let ctaButtons = [];
    if (userId) {
      const ctaButton = BlockerButtonHelper.create({
        type: 'black',
        text: message.cta,
        onclick: Adult.adultCallback(blocker, userId),
      });
      ctaButtons.push(ctaButton);
    } else {
      const ctaButton = blocker.buttonHelper.withDirectLinkButton({
        type: 'white',
        text: message.signInCta,
        href: Adult.getSignInUrl()
      });
      ctaButtons.push(ctaButton);
    }

    player.tech?.()?.pause?.();
    let element = blocker.renderBlockerWithParam({ message, ctaButtons, haveCloseButton: false, withBgImg: true });
    element.classList.add('vjs-player-error__section--full');
  }

  static createAdultNotice() {
    const notice = document.createElement("div");
    const preventClickPassThroughPlayer = (e) => {
      e.stopPropagation();
    };
    notice.className = "vjs-adult";
    notice.onclick = preventClickPassThroughPlayer;
    notice.ontouchend = preventClickPassThroughPlayer;

    return notice;
  }

  static setAdultConfirmId(userId) {
    const adultConfirmId = CookieUtils.getCookie('adult_confirm_id');

    if (adultConfirmId !== userId) {
      CookieUtils.setCookie('adult_confirm_id', userId, Adult.getAdultConfirmExpiry());
    }
  }

  static getSignInUrl() {
    const path = PlayerEnvironment.pathname();
    const search = PlayerEnvironment.locationSearch();

    return `/users/login?user_return_to=${path}${search}`;
  }

  static userHasConfirm(userId, adultConfirmId) {
    return userId == adultConfirmId;
  }

  static getAdultConfirmExpiry() {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);

    return expiryDate.toUTCString();
  }

  static sendEvent(data) {
    PlayerAhoyEvent.sendBlocker(
      data?.type()?.toLowerCase(),
      data?.isPremier(),
      data?.videoId(),
      'adult_confirm'
    );
  }
}
